import { Component, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiciosService } from '../services/servicios.service';
import { AccessService } from '../../core/services/access.service';
import { Servicio, Servicios } from '../models/servicio.model';
import { ServicioFormComponent } from "../servicio-form/servicio-form.component";
import { ServicioInterface } from '../interfaces/servicio.interface';

@Component({
  selector: 'app-servicio-details',
  standalone: true,
  imports: [ServicioFormComponent],
  templateUrl: './servicio-details.component.html',
  styleUrl: './servicio-details.component.css'
})
export class ServicioDetailsComponent {
  private route = inject(ActivatedRoute)
  private service = inject(ServiciosService)

  protected access = inject(AccessService).access
  protected id!: string | null;

  value = model<Servicio | undefined>(undefined)
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Dealles del Servicio')
    // this.route.url.subscribe(url => {
    //   console.log(`SERVICIO DETALLES  URL: ${url}`)
    // })
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.service.get(params.get('id')).subscribe(data => {
        this.value.update(value => (value = new Servicio(data as ServicioInterface)));
      });
    });
  }
}
